const navbarProfileMenuPage = () => {
  const profileMenuWrapper = document.querySelector(
    ".navbar-profile__outer-wrapper"
  );

  if (profileMenuWrapper) {
    const profileMenuTrigger = document.querySelector(
      ".navbar-profile__menu-notification-wrapper"
    );

    profileMenuTrigger.addEventListener("click", (e) => {
      profileMenuWrapper.classList.toggle("profileMenuOpen");
    });

    profileMenuTrigger.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        profileMenuWrapper.classList.toggle("profileMenuOpen");
      }
    });

    document.addEventListener("scroll", () => {
      if (profileMenuWrapper.classList.contains("profileMenuOpen")) {
        profileMenuWrapper.classList.remove("profileMenuOpen");
      }
    });

    // Close the menu if clicked outside
    document.addEventListener("click", (e) => {
      if (
        profileMenuWrapper.classList.contains("profileMenuOpen") &&
        !profileMenuWrapper.contains(e.target)
      ) {
        profileMenuWrapper.classList.remove("profileMenuOpen");
      }
    });
  }
};

if (document.readyState !== "loading") {
  navbarProfileMenuPage();
} else {
  document.addEventListener("DOMContentLoaded", navbarProfileMenuPage);
}
